import React, { useMemo } from 'react';
import { BaseNav } from './base-nav.component';
import { useNav } from '../../nav.context';
import { useNavSearch } from './search/useSearch.hook';
import { permissionChecks } from '../primary-navbar.helper';
import { getPhoneFormat, highlightMatch } from './search/nav-search.helper';
import { searchContacts } from './search/nav-search.resources';
import { featureEnabled } from 'feature-toggles!sofe';

const categories = [
  { id: 0, key: 'name', title: 'Name', icon: 'person' },
  {
    id: 1,
    key: 'display_name',
    title: 'Display name',
    icon: 'person',
    featureToggles: ['crm_display_name']
  },
  {
    id: 2,
    key: 'email',
    title: 'Email address',
    icon: 'communication-envelope',
  },
  {
    id: 3,
    key: 'phone',
    title: 'Phone number',
    icon: 'communication-phone',
    isPhone: true,
  },
  {
    id: 4,
    key: 'external_id',
    title: 'External ID',
    icon: 'misc-id-external'
  },
];

export const ContactsNav = () => {
  const nav = useNav();
  const navLinks = useMemo(() => {
    return [
      { label: 'Contact List', url: 'clients', enabled: !!nav.user.effective_permissions.contacts },
      {
        label: 'Manage Client Portals',
        url: 'contacts/portal/client-portal-users',
        enabled: permissionChecks.canManageClientPortals(nav.user) && !permissionChecks.transcriptsOnly(nav.user),
      },
    ];
  }, [nav.user]);
  const getContactLink = item => {
    return `#/client/${item.id}`;
  };

  const closeNav = () => nav.setSecondaryOpen(null);

  const [searchInput, loading, searchString, handleSearch, searchResults, hoverIndex] = useNavSearch(
    searchContacts,
    getContactLink,
    closeNav
  );

  const getDisplayValue = (item, category, searchTerm) =>
    highlightMatch(category.isPhone ? getPhoneFormat(item.value) : item.value, searchTerm);

  return (
    <BaseNav
      title="Contacts"
      nav={nav}
      searchHook={{
        searchInput,
        loading,
        searchString,
        handleSearch,
        searchResults,
        hoverIndex,
      }}
      searchParams={{
        placeholder: 'contacts',
        showRecent: true,
        recentStorageKey: 'recentContacts',
        showSearch: true,
        link: getContactLink,
        getDisplayValue: getDisplayValue,
        displayKey: 'name',
      }}
      categories={categories.filter(cat => cat.featureToggles ? featureEnabled(...cat.featureToggles) : true)}
      navLinks={navLinks}
    />
  );
};
